import React from 'react'
import { useIntl } from 'react-intl'
import ButtonCinestar from '../../../../../components/Buttons/ButtonCinestar/ButtonCinestar'

export default function ProlongMembershipButton({ cardsInBasket, handleCardProlonge, removeCard }) {
    const intl = useIntl()
    return (
        <>
            {!cardsInBasket?.[0] ? (
                //IF NO CARD ADD TO CARD
                <ButtonCinestar variant={'primary-v1'} className={'text-uppercase'} onClick={handleCardProlonge}>
                    {intl.formatMessage(
                        { id: 'buttons.extendMembership' },
                        { span: (chunks) => <span>{chunks}</span> }
                    )}
                </ButtonCinestar>
            ) : (
                <ButtonCinestar variant={'primary-v1'} className={'text-uppercase'} onClick={removeCard}>
                    {intl.formatMessage(
                        { id: 'buttons.extendMembershipRemove' },
                        { span: (chunks) => <span>{chunks}</span> }
                    )}
                </ButtonCinestar>
            )}
        </>
    )
}
